import { render } from "./CreditOwner.vue?vue&type=template&id=ed240c80"
import script from "./CreditOwner.vue?vue&type=script&lang=js"
export * from "./CreditOwner.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__